import { render } from "./AddNewCrewmateModal.vue?vue&type=template&id=9012278a"
import script from "./AddNewCrewmateModal.vue?vue&type=script&lang=js"
export * from "./AddNewCrewmateModal.vue?vue&type=script&lang=js"

import "./AddNewCrewmateModal.vue?vue&type=style&index=0&id=9012278a&lang=css"
script.render = render

export default script